export enum SupportedCurrenciesEnum {
  ETH = "Ethereum",
  DAI = "Dai Stablecoin",
  USDT = "Tether USD",
  WBTC = "Wrapped Bitcoin",
}
